import type { Theme } from '@mui/material';
// import type { Components } from '@mui/material/styles';

export default function MUIListItem(theme: Theme) /*: Components['MuiListItem']*/ {
  return {
    // defaultProps: {},
    styleOverrides: {
      dense: {
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5),
      },
    },
    // variants: [],
  };
}
